import { http } from '../../http';
import {
    RequestGetLibraryDashboards,
    RequestGetLibraryWidgets,
    ResponseGetLibraryDashboards,
    ResponseGetLibraryWidgets,
} from './types';

export const getLibraryDashboards = async () => {
    return http
        .get<RequestGetLibraryDashboards, ResponseGetLibraryDashboards>('/library/dashboards')
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error fetching library dashboards:', error);
            throw error;
        });
};

export const getLibraryWidgets = async () => {
    return http
        .get<RequestGetLibraryWidgets, ResponseGetLibraryWidgets>('/library/widgets')
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error fetching library widgets:', error);
            throw error;
        });
};
